import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import Icon from 'flarum/common/components/Icon';
import { listGiveaways, listCategories } from '../../common/api';
import GiveawayCard from '../components/GiveawayCard';
import GiveawayFormModal from '../components/GiveawayFormModal';
import CategoryManagerModal from '../components/CategoryManagerModal';
export default class GiveawaysPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "giveaways", []);
    _defineProperty(this, "categories", []);
    _defineProperty(this, "canCreate", false);
    _defineProperty(this, "canManage", false);
    _defineProperty(this, "filter", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    app.setTitle(app.translator.trans('ernestdefoe-giveaways.forum.page_title'));
    this.load();
    this.loadCategories();
  }
  load() {
    this.loading = true;
    listGiveaways().then(res => {
      this.giveaways = res.data || [];
      this.canCreate = !!(res.meta && res.meta.canCreate);
      this.canManage = !!(res.meta && res.meta.canManage);
      this.loading = false;
      m.redraw();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
  loadCategories() {
    listCategories().then(res => {
      this.categories = res.data || [];
      m.redraw();
    });
  }
  create() {
    app.modal.show(GiveawayFormModal, {
      categories: this.categories,
      onsave: () => this.load()
    });
  }
  manageCategories() {
    app.modal.show(CategoryManagerModal, {
      onchange: () => this.loadCategories()
    });
  }
  matchesFilter(g) {
    return this.filter === null || g.category && g.category.id === this.filter || false;
  }
  view() {
    const filtered = this.giveaways.filter(g => this.matchesFilter(g));
    const active = filtered.filter(g => g.status === 'active');
    const past = filtered.filter(g => g.status !== 'active');
    return m("div", {
      className: "GiveawaysPage"
    }, m("div", {
      className: "GiveawaysPage-hero"
    }, m("div", {
      className: "container"
    }, m("h1", {
      className: "GiveawaysPage-title"
    }, app.translator.trans('ernestdefoe-giveaways.forum.heading')), m("p", {
      className: "GiveawaysPage-subtitle"
    }, app.translator.trans('ernestdefoe-giveaways.forum.subheading')), m("div", {
      className: "GiveawaysPage-actions"
    }, this.canCreate && m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-plus",
      onclick: () => this.create()
    }, app.translator.trans('ernestdefoe-giveaways.forum.create')), this.canManage && m(Button, {
      className: "Button",
      icon: "fas fa-tags",
      onclick: () => this.manageCategories()
    }, app.translator.trans('ernestdefoe-giveaways.forum.categories.manage'))))), m("div", {
      className: "container GiveawaysPage-content"
    }, this.categories.length > 0 && m("div", {
      className: "GiveawaysPage-filters"
    }, m("button", {
      className: 'GiveawayFilter' + (this.filter === null ? ' is-active' : ''),
      onclick: () => {
        this.filter = null;
      }
    }, app.translator.trans('ernestdefoe-giveaways.forum.categories.all')), this.categories.map(c => m("button", {
      key: c.id,
      className: 'GiveawayFilter' + (this.filter === c.id ? ' is-active' : ''),
      style: this.filter === c.id ? {
        backgroundColor: c.color,
        borderColor: c.color,
        color: '#fff'
      } : {
        color: c.color,
        borderColor: c.color
      },
      onclick: () => {
        this.filter = c.id;
      }
    }, c.icon && m(Icon, {
      name: c.icon
    }), " ", c.name))), this.loading ? m(LoadingIndicator, null) : filtered.length === 0 ? m("div", {
      className: "GiveawaysPage-empty"
    }, app.translator.trans('ernestdefoe-giveaways.forum.empty')) : [active.length > 0 && m("section", null, m("h2", {
      className: "GiveawaysPage-sectionTitle"
    }, app.translator.trans('ernestdefoe-giveaways.forum.active_heading')), m("div", {
      className: "GiveawaysPage-grid"
    }, active.map(g => m(GiveawayCard, {
      key: g.id,
      giveaway: g
    })))), past.length > 0 && m("section", null, m("h2", {
      className: "GiveawaysPage-sectionTitle"
    }, app.translator.trans('ernestdefoe-giveaways.forum.past_heading')), m("div", {
      className: "GiveawaysPage-grid"
    }, past.map(g => m(GiveawayCard, {
      key: g.id,
      giveaway: g
    }))))]));
  }
}
flarum.reg.add('ernestdefoe-giveaways', 'forum/pages/GiveawaysPage', GiveawaysPage);